// extracted by mini-css-extract-plugin
export default {"styledProgressBar":"_3nhuSNPS","progressBarLabel":"_1A71JyJS"};